function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0546875,25.28125 C18.2890625,25.28125 18.5234375,25.1875 18.6953125,25.0078125 L23.84375,19.8515625 C24.03125,19.6640625 24.1171875,19.453125 24.1171875,19.2265625 C24.1171875,18.734375 23.7578125,18.375 23.28125,18.375 C23.0390625,18.375 22.8203125,18.4765625 22.6640625,18.6328125 L20.8828125,20.3984375 L18.859375,22.65625 L18.921875,20.96875 L18.921875,11.3203125 C18.921875,10.8046875 18.5625,10.4453125 18.0546875,10.4453125 C17.5390625,10.4453125 17.1796875,10.8046875 17.1796875,11.3203125 L17.1796875,20.96875 L17.25,22.6640625 L15.21875,20.3984375 L13.4453125,18.6328125 C13.2890625,18.4765625 13.0703125,18.375 12.8203125,18.375 C12.34375,18.375 11.9921875,18.734375 11.9921875,19.2265625 C11.9921875,19.453125 12.078125,19.6640625 12.265625,19.8515625 L17.40625,25.0078125 C17.578125,25.1875 17.8125,25.28125 18.0546875,25.28125 Z",
  fill: "#999999",
  fillRule: "nonzero"
}));

var SvgArrowDownGrey = function SvgArrowDownGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down-grey.6bedb1c8.svg";
export { ForwardRef as ReactComponent };